export default __webpack_public_path__ + "static/media/XLM.c977c23c.svg";